import PropTypes from 'prop-types';

import styles from "./QuoteCard.module.css";

const renderQuote = (quote) => {
  let text, author;
  // render quote text
  if (quote.text) {
    text = (
      <div className={styles["quote-card__text"]}>
        <p>
          <q className={styles["quote"]}>{quote.text} </q>
        </p>
      </div>
    )
  }

  //render quote author
  if (quote.author) {
    author = (
      <div className={styles["quote-card__author"]}>&ndash; {quote.author}</div>
    );
  }


  return (
    <div className={styles["quote-card"]}>
      {text}
      {author}
    </div>
  );
};

const QuoteSlider = (props) => {
  const {
    quote = {}
  } = props;
  return (renderQuote(quote));

}

export default QuoteSlider;

QuoteSlider.propTypes = {
  quote: PropTypes.object
};
